import { Config } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { GlobalState } from '@leverege/ui-redux';
import CreateItem from "../view/CreateItem.js";
import MapProvider from "../../dataViewers/map/mapbox/MapProvider.js";
const {
  t,
  tf
} = I18N.ns('molten.imagine.actions.CreateAction');
const create = relationship => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.CreateItem`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    layout: {
      sort: 'item.add1',
      sectionName: t('sectionName', {
        blueprintName: blueprint.name
      })
    },
    prepare: cxt => {
      return GlobalState.dispatch(cxt?.clientProps?.delegate?.requestCanCreate());
    },
    isPrepared: cxt => {
      return cxt?.clientProps?.delegate?.canCreate() != null;
    },
    handles: cxt => {
      const can = cxt?.clientProps?.delegate?.canCreate();
      return can === true;
    },
    appearance: () => {
      return {
        name: t('appearanceName', {
          blueprintName: blueprint.name
        }),
        icon: Config.get('BlueprintActions', 'createIcon', 'https://storage.googleapis.com/molten-ui-assets/create-action.png')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          delegate
        }
      } = context;

      // Can we make it in the map? If so, install the pointer
      if (MapProvider.isMapAvailable()) {
        const map = MapProvider.get();
        const GeoJsonPointer = map.constructor.GeoJsonPointerType;
        const attr = blueprint.attributes.find(attr => attr.type === 'geoJson');
        if (attr && GeoJsonPointer) {
          MapProvider.setPointer(new GeoJsonPointer({
            ...context,
            target: null,
            feature: null,
            attribute: attr,
            relationship,
            delegate,
            map: map.map
          }));
          return;
        }
      }
      Dialogs.show({
        component: CreateItem,
        props: {
          delegate,
          relationship
        }
      });
    }
  };
};
export default {
  create
};